import React, { useState, useEffect } from 'react'
import styles from './LessonItem.module.css'
import firebase from 'firebase/app';
import 'firebase/storage'


const LessonItem = ({
    title,
    imageUrl,
    scores,
    stages,
    open,
    onClick,
}) => {

    const [imgUrl, setImgUrl] = useState(null)
    const [lessonScore, setLessonScore] = useState(-1)

    useEffect(() => {
        firebase.storage().refFromURL(imageUrl).getDownloadURL()
            .then((url) => {
                setImgUrl(url)
            })
    }, [imageUrl])

    useEffect(() => {
        if (!scores || scores === undefined) return
        let count = 0;
        let scoresSum = 0;
        let scoresLength = 0;


        for (let stageKey of Object.keys(scores)) {
            if (stages.includes(stageKey)) {
                count += 1
                if (Number(scores[stageKey]) !== -1) {
                    scoresSum += Number(scores[stageKey])
                    scoresLength += 1
                }
            }
        }
        if (count === stages.length) {
            setLessonScore(String(Math.round((scoresSum / scoresLength) * 10) / 10))
        }
    }, [scores, stages])

    return (
        <div 
            className={styles.container}
            style={open ? {} : {opacity: 0.3}}
            onClick={onClick}>
            <div className={styles.imgContainer}>
                <img 
                    src={imgUrl} 
                    className={styles.img} 
                    alt="lesson"/>
            </div>

            <span className={styles.title}>{title}</span>
            {
                Number(lessonScore) === -1 ?
                    <div style={{ height: '64px'}} /> :
                    <span
                        className={styles.score}
                        style={{
                            backgroundColor: Number(lessonScore) === 10 ?
                                '#26C281' :
                                Number(lessonScore) > 6 ?
                                    '#309CFF' :
                                    '#FF6464'
                        }}>{lessonScore}</span>
            }

        </div>
    )
}

export default LessonItem
